import { IonToggleCustomEvent } from '@ionic/core';
import {
    IonCol,
    IonItem,
    IonLabel,
    IonList,
    IonRow,
    IonToggle,
} from '@ionic/react';
import { Trans } from '@lingui/macro';
import React, { FC } from 'react';

import { THomeAssetData } from '../../types/HomeAssetData';

interface IDevicesLocation {
    devicesList: THomeAssetData[];
    onToggleChange: (e: IonToggleCustomEvent<any>) => void;
    retainDevicesAtSite: boolean;
}

const DevicesLocation: FC<IDevicesLocation> = ({
    devicesList,
    retainDevicesAtSite,
    onToggleChange,
}) => {
    return (
        <>
            <IonRow className="ion-justify-content-between ion-align-items-center ion-margin-top ion-margin-bottom">
                <IonCol>
                    <IonLabel>
                        <Trans>
                            Are the devices added during this intervention
                            still physically located at the customer's house?
                        </Trans>
                    </IonLabel>
                </IonCol>
                <IonCol size="auto">
                    <IonToggle
                        color="primary"
                        onIonChange={onToggleChange}
                        name="retainDevicesAtSite"
                        checked={retainDevicesAtSite}
                    />
                </IonCol>
            </IonRow>
            {devicesList.length > 0 ? (
                <>
                    <IonRow className="ion-justify-content-between ion-align-items-center ion-margin-top ion-margin-bottom">
                        <IonLabel>
                            <Trans>Added devices:</Trans>
                        </IonLabel>
                    </IonRow>
                    <IonList class="ion-margin-bottom">
                        {devicesList.map((d, index) => (
                            <IonItem key={index}>
                                <IonLabel>{d.macAddress}</IonLabel>
                            </IonItem>
                        ))}
                    </IonList>
                    {!retainDevicesAtSite ? (
                        <IonRow className="ion-justify-content-between ion-align-items-center ion-margin-top ion-margin-bottom">
                            <Trans>
                                Please go to the wiring step to remove
                                uninstalled devices before recording the KO
                                reason.
                            </Trans>
                        </IonRow>
                    ) : null}
                </>
            ) : null}
        </>
    );
};

export default DevicesLocation;
